// @ts-nocheck
import dataReducer, { DataActions } from "@store/Framework/Store/Store/Data/DataReducer";
import pagesReducer, { PagesActions } from "@store/Framework/Store/Store/Pages/PagesReducer";
import { combineReducers } from "redux";

const storeReducer = combineReducers({
    data: dataReducer,
    pages: pagesReducer,
});

export type StoreActions = DataActions | PagesActions;

export default storeReducer;
